import { Home, Triangle, Bath, Eye, Trees, Sparkles } from "lucide-react";

const CATEGORIES = [
  { id: "all", label: "Toate", icon: Sparkles },
  { id: "a-frame", label: "A-Frame", icon: Triangle },
  { id: "chalet", label: "Chalete de lux", icon: Home },
  { id: "ciubar", label: "Ciubăr & Saună", icon: Bath },
  { id: "priveliste", label: "Cu priveliște", icon: Eye },
  { id: "cabana", label: "Cabane rustice", icon: Trees },
];

export function CategoryBar({ active, onChange }) {
  return (
    <div className="border-b border-border/60 bg-background/80 backdrop-blur-sm sticky top-16 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex gap-8 overflow-x-auto no-scrollbar py-4">
          {CATEGORIES.map((c) => {
            const Icon = c.icon;
            const isActive = active === c.id;
            return (
              <button key={c.id} onClick={() => onChange(c.id)} data-testid={`filter-category-${c.id}`}
                      className={`flex flex-col items-center gap-2 min-w-fit pb-2 border-b-2 transition-all ${
                        isActive ? "border-accent text-foreground" : "border-transparent text-muted-foreground hover:text-foreground hover:border-border"
                      }`}>
                <Icon className={`h-6 w-6 ${isActive ? "text-accent" : ""}`} />
                <span className="text-xs font-medium whitespace-nowrap">{c.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
